export const SESSION_STORAGE_KEYS = {
  BILLS_OVERDUE_BANNER_HIDDEN: 'billsOverdueBannerHidden',
  EMAIL: 'email',
  TENANT_NAME: 'tenant_name',
};
